import React, { createContext, useContext, useState } from 'react';

export type Device = 'desktop' | 'tablet' | 'mobile';

const DeviceTypeContext = createContext<Device>('desktop');

type Props = {
    children: React.ReactNode;
    initialValue: Device;
};
export const DeviceTypeProvider = ({ children, initialValue }: Props) => {
    const [deviceType] = useState(initialValue);

    return <DeviceTypeContext.Provider value={deviceType}>{children}</DeviceTypeContext.Provider>;
};
DeviceTypeProvider.displayName = 'DeviceTypeContext';

export const useDeviceType = (): Device => {
    const context = useContext(DeviceTypeContext);

    return context;
};
